import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ef3a012"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "card-page card-page-opened" }
const _hoisted_3 = ["srcset"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "card-page-container" }
const _hoisted_6 = { class: "card-page-section" }
const _hoisted_7 = { class: "card-page-close" }
const _hoisted_8 = { class: "description" }
const _hoisted_9 = { class: "card-page-info" }
const _hoisted_10 = { class: "card-page-weight" }
const _hoisted_11 = {
  key: 0,
  class: "price"
}
const _hoisted_12 = {
  key: 0,
  class: "card-page-addition"
}
const _hoisted_13 = { class: "card-page-addition-title" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "Добавь для вкуса:", -1))
const _hoisted_15 = { class: "price" }
const _hoisted_16 = { class: "card-page-addition-container" }
const _hoisted_17 = { class: "title" }
const _hoisted_18 = { class: "price" }
const _hoisted_19 = { class: "actions" }
const _hoisted_20 = ["onClick", "disabled"]
const _hoisted_21 = { class: "count" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "card-page-actions" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Итого:", -1))
const _hoisted_25 = { class: "price" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.mealData)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("picture", null, [
            _createElementVNode("source", {
              srcset: _ctx.mealData.smallImgUrl,
              media: "(max-width: 630px)"
            }, null, 8, _hoisted_3),
            _createElementVNode("img", {
              src: _ctx.mealData.largeImgUrl,
              alt: _ctx.mealData.name
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: {
              name: 'Home',
              hash: '#' + _ctx.getSectionDataById(_ctx.mealData.sectionId).url,
            },
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeDisplayedMealId(0)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.getSectionDataById(_ctx.mealData.sectionId).name), 1)
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", {
                class: "close",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeDisplayedMealId(0)))
              })
            ]),
            _createElementVNode("h3", null, _toDisplayString(_ctx.mealData.name), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.mealData.description), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.mealData.weight), 1),
              (_ctx.mealData.additions.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.mealData.price), 1))
                : _createCommentVNode("", true)
            ]),
            (_ctx.mealData.additions.length)
              ? (_openBlock(), _createElementBlock("details", _hoisted_12, [
                  _createElementVNode("summary", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.getAdditionsCost(_ctx.basketItem.additions)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mealData.additions, (item, key) => {
                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (_ctx.getAdditionDataById(item))
                          ? (_openBlock(), _createElementBlock("div", {
                              class: _normalizeClass(["card-page-addition-element", { selected: _ctx.basketItem.additions[item] }]),
                              key: key
                            }, [
                              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.getAdditionDataById(item).name), 1),
                              _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.getAdditionDataById(item).price), 1),
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("button", {
                                  class: "reduce",
                                  onClick: ($event: any) => (_ctx.changeAdditionCount(item, _ctx.basketItem.additions[item] - 1)),
                                  disabled: _ctx.basketItem.additions[item] == 0
                                }, null, 8, _hoisted_20),
                                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.basketItem.additions[item]), 1),
                                _createElementVNode("button", {
                                  class: "add",
                                  onClick: ($event: any) => (_ctx.changeAdditionCount(item, _ctx.basketItem.additions[item] + 1))
                                }, null, 8, _hoisted_22)
                              ])
                            ], 2))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 256))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.getBasketItemCost(_ctx.basketItem)), 1),
              _createElementVNode("button", {
                class: "btn-main",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addToBasket()))
              }, "Заказать")
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}